var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9504 20.3885C15.6337 20.3885 15.3171 20.3126 15.0671 20.1501L4.95039 13.5743C4.46706 13.2601 4.46706 12.7401 4.95039 12.426L15.0671 5.85013C15.5504 5.53596 16.3504 5.53596 16.8337 5.85013C17.3171 6.16429 17.3171 6.68429 16.8337 6.99846L7.60039 13.0001L16.8337 19.0018C17.3171 19.316 17.3171 19.836 16.8337 20.1501C16.6004 20.3126 16.2671 20.3885 15.9504 20.3885Z",
    fill: "#562C62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1662 13.8125H6.11621C5.43288 13.8125 4.86621 13.4442 4.86621 13C4.86621 12.5558 5.43288 12.1875 6.11621 12.1875H34.1662C34.8495 12.1875 35.4162 12.5558 35.4162 13C35.4162 13.4442 34.8495 13.8125 34.1662 13.8125Z",
    fill: "#562C62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.da4a0785.svg";
export { ForwardRef as ReactComponent };